import {AssetsHistory} from '@hconnect/common/types'
import {useQuery} from '@tanstack/react-query'

import {ASSETS_HISTORY_QUERY_KEY, MomentRange, assetsHistoryQueryOptions} from './assetsHistoryQueryOptions'

export type {MomentRange}
export {ASSETS_HISTORY_QUERY_KEY}

interface UseAssetsHistoryQueryParams {
  plantId: string
  timeFrame: MomentRange
  enabled?: boolean
  throwOnError?: boolean
}

export const useAssetsHistoryQuery = <TSelect = AssetsHistory>({
  plantId,
  timeFrame,
  enabled = true,
  throwOnError = true,
  select
}: UseAssetsHistoryQueryParams & {
  select?: (data: AssetsHistory) => TSelect
}) => {
  return useQuery<AssetsHistory, unknown, TSelect>({
    ...assetsHistoryQueryOptions(plantId, timeFrame),
    throwOnError,
    enabled,
    ...(enabled ? {} : {gcTime: 0}),
    ...(select ? {select} : {})
  })
}
